<template>
  <div class="content-checkbox">
    <input
      v-model="checked"
      type="checkbox"
      :value="component.name"
      class="cb"
    />
    <label class="text-value">{{ component.label }}</label>
  </div>
</template>
<script>
export default {
  name: 'Checkbox',

  props: {
    component: {
      type: Object,
      required: true,
    },
  },

  data: () => ({
    checked: false,
  }),
}
</script>
<style scoped>
.content-checkbox {
  display: flex;
  padding: 5px;
}
.text-value {
  /* font-weight: bold; */
  font-size: 14px;
  font-family: 'Rajdhani', sans-serif;
  color: #69739e;
  padding-left: 10px;
}

.cb {
  -webkit-appearance: none;
  appearance: none;
  width: 20px;
  height: 20px;
  border-radius: 4px;
  cursor: pointer;
  background-color: white;
  border: 2px solid #10dd2c;
  position: relative;
  display: inline-block;
}

.cb::before {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  width: 10px;
  height: 10px;
  transform: translate(-50%, -50%) scale(0);
  transition: transform 0.2s ease-in-out;
  clip-path: polygon(14% 44%, 0 65%, 50% 100%, 100% 16%, 80% 0%, 43% 62%);
  background-color: #10dd2c;
}

.cb:checked {
  background-color: white;
  border-color: #10dd2c;
}

.cb:checked::before {
  transform: translate(-50%, -50%) scale(1); /* Exibe o 'V' */
}
</style>
